import withWidth from '@material-ui/core/withWidth';
import React, { Component } from 'react';

import { MyTableContext } from '..';
import styles from '../styles';

interface IProps {
  width?: any;
  responsive?: boolean;
  classes?: any;
}

class MyTableBody extends Component<IProps, {}> {
  render() {
    const { classes, width, responsive } = this.props;

    if (!responsive || width === 'md' || width === 'lg' || width === 'xl') {
      return <tbody className={classes.tBody}>{this.props.children}</tbody>;
    }

    return <div className={classes.tBody}>{this.props.children}</div>;
  }
}

export default withWidth()(
  styles(
    React.forwardRef((props: IProps, ref: any) => (
      <MyTableContext.Consumer>{(context) => <MyTableBody {...props} {...context} ref={ref} />}</MyTableContext.Consumer>
    ))
  )
);
